import "./administradores.scss";
import React, { useState } from "react";
import TituloCard from "../../atoms/titles/Titulo";
import { Link } from "react-router-dom";
import FormularioAdmnistradores from "../../molecules/modals/formularioAdministradores/FormularioAdmnistradores";
import ListadoAdministradores from "../../molecules/modals/listadoAdministradores/ListadoAdministradores";

const Administradores = () => {
  const [show, setShow] = useState({ nuevo: false, editar: false });
  const handleClose = (e) => {
    setShow(false);
  };
  return (
    <>
      <TituloCard tipo="tituloModal" titulo={<h2 className="tituloPagina4">Administradores</h2>} />
      <div className="">
        <div className="d-flex flex-column">
          <div
            onClick={() => {
              setShow({ nuevo: true });
            }}
          >
            <i className="fa-solid fa-caret-right my-2">
              <Link to={""} className="fw-light">
                {" "}
                Nuevo Administrador
              </Link>
            </i>
          </div>
          <div
            className=""
            onClick={() => {
              setShow({ editar: true });
            }}
          >
            <i className="fa-solid fa-caret-right my-2">
              <Link to={""} className="fw-light">
                {" "}
                Editar / Eliminar Administradores
              </Link>
            </i>
          </div>
        </div>
      </div>
      {show?.nuevo ? (
        <>
          <FormularioAdmnistradores
            show={show.nuevo}
            handleClose={handleClose}
          ></FormularioAdmnistradores>
        </>
      ) : null}
      {show?.editar ? (
        <>
          <ListadoAdministradores
            show={show.editar}
            handleClose={handleClose}
            usuario={undefined}
          ></ListadoAdministradores>
        </>
      ) : null}
    </>
  );
};
export default Administradores;
